"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = keys;

// returns indexes
function keys() {
  var length = this.length;
  var result = new Array(length);

  for (var i = 0; i < length; i++) {
    result[i] = i;
  }

  return result;
}
//# sourceMappingURL=keys.js.map